import * as Yup from 'yup';

import { validatePhone, phoneMessage } from './phone';

// DTGD-1780: regra Yup de telefone com a mensagem do motivo. Fica fora de
// phone.js para aquele arquivo seguir sem dependências (copiável para o back).
export const phoneRule = rules =>
  Yup.string().test('phone', '', function (value) {
    return (
      validatePhone(value, rules).valid ||
      this.createError({ message: phoneMessage(value, rules) })
    );
  });
